import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class CustomMatSelectService {
  public scrollSelectedOptionIntoView(index: number): void {
    const optionElements = document.querySelectorAll('mat-option');

    if (!optionElements[index]) { return; }

    optionElements[index].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }
}
